import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AffectedTour } from './assign-sub-project-to-tour-controller-request.service';

@Injectable({
  providedIn: 'root',
})
export class TourPlanningEventService {
  private tourChangedForPlacers = new Subject<AffectedTour[]>();

  public getTourChangedForPlacersSubject(): Subject<AffectedTour[]> {
    return this.tourChangedForPlacers;
  }

  private subProjectWasAssigned = new Subject<number>();

  public getSubProjectWasAssignedSubject(): Subject<number> {
    return this.subProjectWasAssigned;
  }

  private subProjectWasUnassigned = new Subject<any>();

  public getSubProjectWasUnassignedSubject(): Subject<any> {
    return this.subProjectWasUnassigned;
  }

  private branchPreviewToggle = new Subject<BranchPreviewToggleEvent>();

  public getBranchPreviewToggleSubject(): Subject<BranchPreviewToggleEvent> {
    return this.branchPreviewToggle;
  }
}

export interface BranchPreviewToggleEvent {
  branchName: string;
  showPreview: boolean;
}
